export default __webpack_public_path__ + "static/media/weekly_xp_empty.22a271b3.svg";